<template>
    <section class="notification">
    <v-container>
        <v-row>
            <v-col cols="14" offset="1">
        <h2 class="section-subtitle">Upozornění</h2>
        <v-row v-if="loading">
            <v-col cols="12" sm="6" offset-sm="3">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else-if="!loading && notifications.length === 0">
            <v-col cols="12" sm="6" offset-sm="3">
                <p>Nemáte žádná upozornění.</p>
            </v-col>
        </v-row>
        <v-row v-else-if="!loading" v-for="notification in notifications" :key="notification.id">
            <v-col class="notification-container">
                <notification-loader :type="notification.type" :data="notification"></notification-loader>
            </v-col>
        </v-row>
    </v-col>
    </v-row>
    </v-container>
</section>
</template>
<script>
    import { captureException as SentryCaptureException } from '@sentry/browser'
    import { LISTING_REQUEST, REMOVE_NOTIFICATION_REQUEST } from '../store/actions/notification'
    import NotificationLoader from '../components/Notification/NotificationLoader';

    export default {
        components: {
            NotificationLoader,
        },
        data () {
            return {
                loading: false,
                notifications: [],
                deleting: false,
            };
        },
        methods: {
            async remove (id) {
                try {
                    this.deleting = true;
                    await this.$store.dispatch('notification/' + REMOVE_NOTIFICATION_REQUEST, { notificationId: id });
                    this.$delete(this.notifications, this.notifications.findIndex(obj => obj.id === id));
                    this.$toast.success('Notifikace byla odstraněna.');
                } catch (e) {
                    SentryCaptureException(e);
                    this.$toast.error('Došlo k chybě při smazání notifikace. Zkuste to později.');
                } finally {
                    this.deleting = false;
                }
            },
        },
        async created () {
            try {
                this.loading = true;
                this.notifications = await this.$store.dispatch('notification/' + LISTING_REQUEST);
            } catch (e) {
                SentryCaptureException(e);
                this.$toast.error('Došlo k chybě při načítání notifikací. Zkuste to později.');
            } finally {
                this.loading = false;
            }
        },
    }
</script>
<style scoped>
    .notification-container {
        position: relative;
    }
    .notification-delete {
        position: absolute;
        right: 16px;
        top: 24px;
    }
</style>
